<template>
  <div class="select-card-modal">
    <el-dialog title="选择落地页" :visible.sync="dialogVisible" width="650px" :append-to-body="true">
      <div class="modal-body">
        <el-form ref="formRef" :rules="rules" :model="formState" label-width="90px">
          <el-form-item label="广告账户" prop="advertiserId">
            <el-select disabled multiple v-model="formState.advertiserId" placeholder="请选择" style="width: 100%" @change="changeCount">
              <el-option
                v-for="item of countList"
                :key="item.advertiserId"
                :label="item.company + item.advertiserName"
                :value="item.advertiserId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择落地页" prop="ldy">
            <el-select v-model="formState.ldy" placeholder="请选择" style="width: 100%">
              <el-option v-for="item of ldyList" :label="item.site_name" :value="item.sitepage_id" :key="item.sitepage_id">
                <span style="float: left">{{ item.site_name }}</span>
                <el-popover placement="right" width="200" trigger="hover">
                  <div class="iframe-wrap">
                    <iframe class="iframe-content" :src="item.sitepage_url" frameborder="0"></iframe>
                  </div>
                  <span slot="reference" style="float: right; color: #0b75ff; font-size: 12px">预览</span>
                </el-popover>
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmData">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getAdCount, getSitePage } from "@/api/promotion.js";
import { mapState } from "vuex";
export default {
  name: "SelectLdy",
  data() {
    return {
      dialogVisible: false,
      countList: [],
      ldyList: [],
      formState: {
        advertiserId: [],
        ldy: null,
      },
      rules: {
        advertiserId: [{ required: true, message: "请选择广告账号", trigger: "change" }],
        ldy: [{ required: true, message: "请选择落地页", trigger: "change" }],
      },
    };
  },
  mounted() {
    this.initAccount();
  },
  methods: {
    initAccount() {
      getAdCount().then((res) => {
        if (res.code === "0000") {
          this.countList = res.advertiseInfos;
        }
      });
    },
    changeCount(val) {
      if (val.length > 0) {
        getSitePage({
          advertiserId: val.join(),
        }).then((res) => {
          if (res.code === "0000") {
            this.ldyList = res.sitePageList;
          }
        });
      }
    },
    confirmData() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          let selectUrl = this.ldyList.find((item) => item.sitepage_id === this.formState.ldy).sitepage_url;
          this.$emit("selectOk", selectUrl);
          this.dialogVisible = false;
        }
      });
    },
    showModal() {
      this.formState.advertiserId = [this.adCount];
      this.changeCount(this.formState.advertiserId);
      this.formState.ldy = null;
      this.dialogVisible = true;
    },
  },
  computed: {
    ...mapState({
      adCount: (state) => state.PromotionTtV2.baseData.advertiser_id,
    }),
  },
};
</script>

<style lang="less" scoped>
.modal-body {
}
.iframe-wrap {
  overflow: hidden;
  width: 200px;
  height: 310px;
  .iframe-content {
    position: absolute;
    left: 0;
    top: 0;
    transform: scale(0.42);
    transform-origin: top left;
    height: 1000px;
    width: 540px;
    border: 0;
    overflow: hidden;
  }
}
</style>
